import { takeLatest, call, put } from 'redux-saga/effects';
import { serializeParams } from 'utils/functions/general';
import masterListActionTypes from './action-types';
import { getServiceCatalog, addService, editService } from './api';
import {
  fetchServicesCatalogSuccess,
  fetchServicesCatalogFail,
  fetchAddServiceSubmissionSuccess,
  fetchAddServiceSubmissionFail,
} from './actions';

function* fetchServicesCatalogSaga({ payload }) {
  try {
    const queryStringOfObj = serializeParams(payload);
    const response = yield call(getServiceCatalog, queryStringOfObj);
    yield put(fetchServicesCatalogSuccess(response.data.Data));
  } catch (error) {
    yield put(fetchServicesCatalogFail(error));
  }
}

function* fetchAddServiceSubmissionSaga({ payload }) {
  try {
    const { addServicePayload, callbackAction } = payload;
    let addServiceSubmissionResponse;
    if (addServicePayload.key) {
      addServiceSubmissionResponse = yield call(
        editService,
        addServicePayload.key,
        addServicePayload,
      );
    } else addServiceSubmissionResponse = yield call(addService, addServicePayload);
    callbackAction();
    yield put(fetchAddServiceSubmissionSuccess(addServiceSubmissionResponse));
  } catch (error) {
    yield put(fetchAddServiceSubmissionFail(error));
  }
}

function* masterListSagas() {
  yield takeLatest(masterListActionTypes.FETCH_SERVICES, fetchServicesCatalogSaga);
  yield takeLatest(
    masterListActionTypes.FETCH_ADD_SERVICE_SUBMISSION,
    fetchAddServiceSubmissionSaga,
  );
}

export default masterListSagas;
